// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2_3Dj","consentsList":"PatientConsents_consentsList__javq5","consentsListEmpty":"PatientConsents_consentsListEmpty__1xgI8"};